// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollable[data-v-b70e492e]{overflow-y:auto;overflow-x:hidden;flex-shrink:1}.participants-search-results__icon[data-v-b70e492e]{margin-top:40px}.participants-search-results__warning[data-v-b70e492e]{margin-top:20px;text-align:center}.participants-search-results__hint[data-v-b70e492e]{margin:20px 0;cursor:pointer}.participants-search-results__hint p[data-v-b70e492e]{margin-top:20px;text-align:center}\n", ""]);
// Exports
module.exports = exports;
